var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-footer"},[_c('div',{staticClass:"app-footer__inner text-center"},[_vm._v(" Copyright "+_vm._s(new Date().getFullYear())+" © "),_c('a',{attrs:{"href":"https://nextgn.dev"}},[_vm._v("NextGN")])])])}
var staticRenderFns = []

export { render, staticRenderFns }